import { TeacherRequestReason, TeacherRequestStatus } from '@/entities/TeacherRequests';
import {
  REQUEST_STATUS_CLASSES,
  REQUEST_STATUS_LABELS,
  formatRequestDate,
  formatRequestDateTime,
} from '../../ui/components/requestUi';

export const TEACHER_REQUEST_REASON_OPTIONS: { value: TeacherRequestReason; label: string }[] = [
  { value: 'annual_leave_request', label: 'Annual Leave Request' },
  { value: 'sick_leave_request', label: 'Sick Leave Request' },
  { value: 'emergency_leave_request', label: 'Emergency Leave Request' },
  { value: 'unpaid_leave_request', label: 'Unpaid Leave Request' },
  { value: 'parental_leave_request', label: 'Parental Leave Request' },
  { value: 'leave_cancellation_adjustment', label: 'Leave Cancellation / Adjustment' },
  { value: 'overtime_request', label: 'Overtime Request' },
  { value: 'overtime_approval', label: 'Overtime Approval' },
  { value: 'employment_confirmation_letter', label: 'Employment Confirmation Letter' },
  { value: 'role_title_change_request', label: 'Role / Title Change Request' },
  { value: 'department_transfer_request', label: 'Department Transfer Request' },
  { value: 'resignation_submission', label: 'Resignation Submission' },
  { value: 'report_student_issue', label: 'Report Student Issue' },
  { value: 'access_request', label: 'Access Request' },
  { value: 'technical_issue', label: 'Technical Issue' },
  { value: 'room_booking_request', label: 'Room Booking Request' },
  { value: 'general_complaint', label: 'General Complaint' },
  { value: 'report_harassment', label: 'Report Harassment' },
  { value: 'other', label: 'Other' },
];

export const TEACHER_REQUEST_REASON_LABELS: Record<TeacherRequestReason, string> =
  TEACHER_REQUEST_REASON_OPTIONS.reduce(
    (acc, option) => ({ ...acc, [option.value]: option.label }),
    {} as Record<TeacherRequestReason, string>,
  );

export const TEACHER_REQUEST_STATUS_LABELS: Record<TeacherRequestStatus, string> =
  REQUEST_STATUS_LABELS;

export const TEACHER_REQUEST_STATUS_CLASSES: Record<TeacherRequestStatus, string> =
  REQUEST_STATUS_CLASSES;

export { formatRequestDate, formatRequestDateTime };
